"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLocale = exports.LocaleProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const PROVIDER_WARNING = 'useLocale hook should be used with a LocaleProvider';
const LocaleContext = (0, react_1.createContext)(undefined);
const LocaleProvider = ({ children, locale, currency: externalCurrency }) => {
    const [currency, setCurrency] = (0, react_1.useState)(externalCurrency);
    (0, react_1.useEffect)(() => {
        setCurrency(externalCurrency);
    }, [externalCurrency]);
    return (0, jsx_runtime_1.jsx)(LocaleContext.Provider, { value: { locale, currency, setCurrency }, children: children });
};
exports.LocaleProvider = LocaleProvider;
const useLocale = () => {
    const localeContext = (0, react_1.useContext)(LocaleContext);
    if (typeof localeContext === 'undefined') {
        // eslint-disable-next-line no-console
        console.warn(PROVIDER_WARNING);
        return {};
    }
    return localeContext;
};
exports.useLocale = useLocale;
